import Snap from 'snapsvg-cjs';
import createDots from './create-dots';
import createTriangle from './create-triangle';

const sectionScore = () => {
  const bg = Snap('.js-scores-bg');
  let circle = null;
  if (bg) {
    if (
      document
        .querySelector('body')
        .classList.contains('post-type-archive-case-study')
    ) {
      circle = bg.circle(545, 860, 320);
      circle.attr({
        fill: 'transparent',
        stroke: '#ff0050',
        strokeWidth: '2px',
      });
    } else {
      createDots(bg, 17, 13, 732, -32);
      circle = bg.circle(1645, 860, 320);
      circle.attr({
        fill: 'transparent',
        stroke: '#ff0050',
        strokeWidth: '2px',
      });
    }
    window.addEventListener('scroll', () => {
      const offset =
        document.querySelector('.c-scores').offsetTop - window.innerHeight / 2;
      circle.attr({
        cy: 1060 - (window.scrollY - offset) / 4,
      });
    });
    if (document.querySelectorAll('.js-all-scores').length > 0) {
      document.querySelector('.js-all-scores').addEventListener('click', e => {
        e.target.classList.add('is-active');
        document.querySelectorAll('.js-score').forEach(element => {
          element.parentElement.classList.remove('u-hidden');
        });
        document.querySelectorAll('.js-filter-scores').forEach(element => {
          element.classList.remove('is-active');
        });
      });
    }
    document.querySelectorAll('.js-filter-scores').forEach(element => {
      element.addEventListener('click', e => {
        document
          .querySelectorAll('.js-filter-scores, .js-all-scores')
          .forEach(element => {
            element.classList.remove('is-active');
          });
        e.target.classList.add('is-active');
        document.querySelectorAll('.js-score').forEach(scores => {
          scores.parentElement.classList.add('u-hidden');
        });
        document
          .querySelectorAll(`.js-filter-${element.dataset.filter}`)
          .forEach(filtered => {
            filtered.parentElement.classList.remove('u-hidden');
          });
      });
    });
  }

  if (document.querySelectorAll('.js-score-anim').length > 0) {
    document.querySelectorAll('.js-score-anim').forEach(element => {
      const s = Snap(element);
      createTriangle(s, 100, 30, 60, 50, 30);
    });

    const animateValue = (obj, start, end, duration) => {
      const range = end - start;
      let current = start;
      const increment = end > start ? 1.13 : -1;
      const stepTime = Math.abs(Math.floor(duration / range));
      const timer = setInterval(() => {
        current += increment;
        obj.querySelector('.js-data').innerHTML = `${Math.round(current * 100) /
          100}`;
        if (current >= end || current >= 1000) {
          clearInterval(timer);
          obj.querySelector('.js-data').innerHTML = `${end}`;
        }
      }, stepTime);
    };
    const scoreAnimation = element => {
      const score = element.querySelector('.js-score-number');
      animateValue(score, 0, score.dataset.score, 2000);
      element.querySelector('.js-score-anim').classList.add('is-active');
    };
    document.addEventListener('aos:in:js-score', ({ detail }) => {
      scoreAnimation(detail);
    });
  }
};

export default sectionScore;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-score.js